import { render, staticRenderFns } from "./organization-platform-roadmap-view.vue?vue&type=template&id=0d18a1a0&scoped=true"
import script from "./organization-platform-roadmap-view.vue?vue&type=script&lang=js"
export * from "./organization-platform-roadmap-view.vue?vue&type=script&lang=js"
import style0 from "./organization-platform-roadmap-view.vue?vue&type=style&index=0&id=0d18a1a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18a1a0",
  null
  
)

export default component.exports